import * as services from 'services/catalogos.service';
import * as types from 'constants/catalogosActionTypes';
import { formatoCatalogos } from 'utils/formatoCatalogos';

export const getAllCatalogos = (data) => async (dispatch) => {
  dispatch({ type: types.GET_LIST_CATALOGS_LOADING });
  try {
    const response = await services.fetchCatalogos(data);
    dispatch({ type: types.GET_LIST_CATALOGS_SUCCESS, payload: formatoCatalogos(response.data) });
    return { success: true, response };
  } catch (error) {
    console.log(3333, error);
    dispatch({ type: types.GET_LIST_CATALOGS_FAILURE, error });
    return { success: false, response: error };
  }
};
